// Language code to full name mapping
export const languageNames: { [key: string]: string } = {
  'af-ZA': 'Afrikaans',
  'am-ET': 'Amharic',
  'ar-XA': 'Arabic',
  'bn-IN': 'Bengali',
  'bg-BG': 'Bulgarian',
  'ca-ES': 'Catalan',
  'cs-CZ': 'Czech',
  'da-DK': 'Danish',
  'de-DE': 'German',
  'el-GR': 'Greek',
  'en-AU': 'English (Australia)',
  'en-GB': 'English (UK)',
  'en-IN': 'English (India)',
  'en-US': 'English (US)',
  'es-ES': 'Spanish',
  'es-US': 'Spanish (US)',
  'et-EE': 'Estonian',
  'fi-FI': 'Finnish',
  'fil-PH': 'Filipino',
  'fr-CA': 'French (Canada)',
  'fr-FR': 'French',
  'gu-IN': 'Gujarati',
  'hi-IN': 'Hindi',
  'hu-HU': 'Hungarian',
  'is-IS': 'Icelandic',
  'id-ID': 'Indonesian',
  'it-IT': 'Italian',
  'ja-JP': 'Japanese',
  'kn-IN': 'Kannada',
  'ko-KR': 'Korean',
  'lv-LV': 'Latvian',
  'lt-LT': 'Lithuanian',
  'ms-MY': 'Malay',
  'ml-IN': 'Malayalam',
  'cmn-CN': 'Chinese',
  'nb-NO': 'Norwegian',
  'nl-NL': 'Dutch',
  'pl-PL': 'Polish',
  'pt-BR': 'Portuguese (Brazil)',
  'pt-PT': 'Portuguese',
  'pa-IN': 'Punjabi',
  'ro-RO': 'Romanian',
  'ru-RU': 'Russian',
  'sr-RS': 'Serbian',
  'sk-SK': 'Slovak',
  'sl-SI': 'Slovenian',
  'sv-SE': 'Swedish',
  'ta-IN': 'Tamil',
  'te-IN': 'Telugu',
  'th-TH': 'Thai',
  'tr-TR': 'Turkish',
  'uk-UA': 'Ukrainian',
  'vi-VN': 'Vietnamese',
};

// Group languages by region/continent
export const languageGroups = {
  'Popular': ['en-US', 'en-GB', 'es-ES', 'fr-FR', 'de-DE', 'it-IT', 'ja-JP', 'ko-KR', 'cmn-CN'],
  'Europe': ['bg-BG', 'ca-ES', 'cs-CZ', 'da-DK', 'de-DE', 'el-GR', 'es-ES', 'et-EE', 'fi-FI', 'fr-FR', 'hu-HU', 'is-IS', 'it-IT', 'lt-LT', 'lv-LV', 'nl-NL', 'pl-PL', 'pt-PT', 'ro-RO', 'sk-SK', 'sl-SI', 'sv-SE'],
  'Asia': ['bn-IN', 'cmn-CN', 'gu-IN', 'hi-IN', 'ja-JP', 'kn-IN', 'ko-KR', 'ml-IN', 'ta-IN', 'te-IN', 'th-TH', 'vi-VN'],
  'Americas': ['en-US', 'es-US', 'fr-CA', 'pt-BR'],
  'Oceania': ['en-AU'],
  'Africa': ['af-ZA', 'am-ET'],
  'Other': ['ar-XA', 'fil-PH', 'id-ID', 'ms-MY', 'uk-UA']
};

// Get display name for language code
export const getLanguageDisplayName = (code: string): string => {
  return languageNames[code] || code;
};

// Get region for language code
export const getLanguageRegion = (code: string): string => {
  for (const [region, codes] of Object.entries(languageGroups)) {
    if (codes.includes(code)) {
      return region;
    }
  }
  return 'Other';
};

// Sort languages by name
export const sortLanguages = (languages: string[]): string[] => {
  return [...languages].sort((a, b) => {
    const nameA = languageNames[a] || a;
    const nameB = languageNames[b] || b;
    return nameA.localeCompare(nameB);
  });
};